import classNames from 'classnames'
import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC } from 'react'

import { getFormattedFinance, IFormattedFinanceOptions } from '../../helpers/getFormattedFinance'

import styles from './FinancialBeautifiedValue.module.scss'

interface IFinancialBeautifiedValueProps extends IFormattedFinanceOptions {
  value?: Nullable<string | number>
  className?: string
}

export const FinancialBeautifiedValue: FC<IFinancialBeautifiedValueProps> = ({
  value,
  className,

  ...options
}) => {
  return (
    <div className={classNames(styles.beautifyValue, className)}>
      {getFormattedFinance(value, options)}
    </div>
  )
}
